import axios from "axios";
import Modal, { ModalHeader, ModalBody, ModalFooter } from "../Modal";
import { ReactTabulator } from "react-tabulator";
import Loader from "../Loader";
import { useEffect, useState } from "react";

export default function RLookUp({
  id,
  variables,
  callBackDataHandler,
  modalHandler: [modalIsOpen, setModalIsOpen],
}) {
  const [tableData, setTableData] = useState();

  let HOST = localStorage.getItem("apiUrl");
  useEffect(() => {
    axios({
      method: "GET",
      url: `${HOST}/RLookup_Table/`,
      params: { kmo: localStorage.getItem("kmo"), rlookupId: id },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((response) => {
        setTableData(response.data);
      })
      .catch((error) => {
        console.log(error.message);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const [modalIsOpen, setModalIsOpen] = useContext(FormContext);

  function modalCallback({ isOpen }) {
    setModalIsOpen(isOpen);
  }

  const [selectedRow, setSelectedRow] = useState();
  function rowClickHandler(e, row) {
    setSelectedRow(row);
  }

  function lookupSubmitHandler(selectedRow) {
    setTableData();
    axios({
      method: "GET",
      url: `${HOST}/RLookup_Data/`,
      // params: { kmo: localStorage.getItem("kmo"), id: selectedRow.getData() },
      params: {
        kmo: localStorage.getItem("kmo"),
        rlookupId: id,
        recordId: selectedRow.getData().primaryKey,
      },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((response) => {
        setModalIsOpen(false);
        callBackDataHandler(response.data);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }

  return (
    <Modal isOpen={modalIsOpen} modalCallback={modalCallback}>
      <ModalHeader
        title={tableData === undefined ? "در حال بارگذاری" : tableData.title}
      />
      <ModalBody>
        {tableData === undefined ? (
          <Loader type="inline" />
        ) : (
          <ReactTabulator
            columns={tableData.columns}
            data={tableData.data}
            options={{ selectable: 1, height: "65vh" }}
            events={{ rowClick: rowClickHandler }}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-success"
          onClick={() => lookupSubmitHandler(selectedRow)}
        >
          انتخاب
        </button>
      </ModalFooter>
    </Modal>
  );
}
